export const DRAWERWIDTH = 240

export const ATTRIBUTE_TYPES = {
  COURSE_ATTRIBUTES: 'Course Attributes',
  STUDENT_COURSE_ATTRIBUTES: 'Student Attributes',
  FACULTY_COURSE_ATTRIBUTES: 'Faculty Attributes',
  USER_COURSE_ATTRIBUTES: 'User Attributes'
} as const
